import React from 'react';
import styled from '@emotion/styled';
import cx from 'classnames';

export interface StyledIconProps {
  iconUrl: string;
}

const StyledIcon = styled.div<StyledIconProps>`
  mask-repeat: no-repeat;
  mask-position: center;
  mask-image: url('${(props) => props.iconUrl}');
`;

export interface MaskedIconProps extends StyledIconProps {
  className?: string;
}

const MaskedIcon = ({ iconUrl, className }: MaskedIconProps) => (
  <StyledIcon
    iconUrl={iconUrl}
    className={cx(className, 'inline-block align-middle bg-white')}
  />
);

export default MaskedIcon;
